import { ReportStatusType } from 'app/modules/reports/reportTypes';
import { constantToDisplayName } from "../core/constantToDisplayName";
import styled from 'styled-components';
import { Box, Button, tombac } from 'tombac';
import { CancelIcon, DownloadIcon, ProcessingIcon, ValidationIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ReportDownloadInfo = ({
  reportStatusInfo,
  onDownload,
  onCancel
}) => {
  const {
    request: report,
    status
  } = reportStatusInfo;
  const reportName = `${constantToDisplayName(report.type)} report ${report.productId.toUpperCase()} ${report.from} -  ${report.to}`;
  const reportStatus = () => {
    switch (status) {
      case ReportStatusType.Done:
        return {
          label: 'is ready to download',
          iconType: /*#__PURE__*/_jsxs(Button, {
            variant: "primary",
            shape: "circle",
            onClick: onDownload,
            children: [/*#__PURE__*/_jsx(DownloadIcon, {}), ' ']
          })
        };
      case ReportStatusType.InProgress:
        return {
          label: 'is processing',
          iconType: /*#__PURE__*/_jsxs(Button, {
            shape: "circle",
            children: [/*#__PURE__*/_jsx(ProcessingIcon, {
              spin: true
            }), ' ']
          })
        };
      case ReportStatusType.Error:
        return {
          label: 'failed to prepare, please try again',
          iconType: /*#__PURE__*/_jsx(Button, {
            disabled: true,
            shape: "circle",
            children: /*#__PURE__*/_jsx(ValidationIcon, {})
          })
        };
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ReportDownload.tsx",
      "data-sentry-element": "Box",
      children: [reportStatus().iconType, /*#__PURE__*/_jsxs(ReportContainer, {
        "data-sentry-element": "ReportContainer",
        "data-sentry-source-file": "ReportDownload.tsx",
        "data-sentry-element": "ReportContainer",
        children: [/*#__PURE__*/_jsx(ReportName, {
          "data-sentry-element": "ReportName",
          "data-sentry-source-file": "ReportDownload.tsx",
          "data-sentry-element": "ReportName",
          children: reportName
        }), /*#__PURE__*/_jsx(ReportStatus, {
          "data-sentry-element": "ReportStatus",
          "data-sentry-source-file": "ReportDownload.tsx",
          "data-sentry-element": "ReportStatus",
          children: reportStatus().label
        })]
      })]
    }), status === ReportStatusType.InProgress && /*#__PURE__*/_jsx(Button, {
      onClick: onCancel,
      shape: "circle",
      variant: "flat",
      prepend: /*#__PURE__*/_jsx(CancelIcon, {})
    })]
  });
};
export default ReportDownloadInfo;
const ReportContainer = styled.div.withConfig({
  displayName: "ReportDownload__ReportContainer"
})(["padding:", ";"], tombac.space(0, 2));
const ReportName = styled.div.withConfig({
  displayName: "ReportDownload__ReportName"
})(["", ""], tombac.text({
  fontWeight: 600
}));
const ReportStatus = styled.div.withConfig({
  displayName: "ReportDownload__ReportStatus"
})(["", ""], tombac.text({
  fontWeight: 400
}));